export default "__VITE_ASSET__CzPPxw5E__"